import React, { useState } from 'react'
import { SubscriptionRecurrenceChange } from '../SubscriptionRecurrenceChange'
import { RecurrenceInterval } from '../../../../../types/recurring-interval'
import { ChangeContractDialog } from './common/ChangeContractDialog'
import { Contract } from '../../../../../types/contract'
import { ContractPaymentInfoBanner } from '../ContractPaymentBanner'
import { translations } from '../../../../../utils/translations/translations-manager'
import { Recurrence } from '../../../../../types/donation/recurrence'
export function SubscriptionRecurrenceChangeDialog({
  subscription,
  visible,
  close,
  success,
}: {
  subscription: Contract
  visible: boolean
  close: () => void
  success: () => void
}): JSX.Element {
  if (!subscription.charityId || !subscription._id) throw new Error('Charity ID and Subscription ID must be defined')
  // Completed used to handle right closing the dialog after the change was successful as success
  const [completed, setCompleted] = useState(false)

  return (
    <ChangeContractDialog
      visible={visible}
      close={completed ? success : close}
      title={completed ? translations.texts.donation_updated.toString() : translations.texts.change_recurrence.toString()}
    >
      {!completed && <ContractPaymentInfoBanner contract={subscription} className="mb-8" />}
      <SubscriptionRecurrenceChange
        contract={subscription}
        success={success}
        complete={() => setCompleted(true)}
        cancel={close}
      />
    </ChangeContractDialog>
  )
}
